import { render, staticRenderFns } from "./MediaRegistration.vue?vue&type=template&id=45653ea4&scoped=true&"
import script from "./MediaRegistration.vue?vue&type=script&lang=js&"
export * from "./MediaRegistration.vue?vue&type=script&lang=js&"
import style1 from "./MediaRegistration.vue?vue&type=style&index=1&id=45653ea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45653ea4",
  null
  
)

export default component.exports